import { render, staticRenderFns } from "./NoResultsButton.vue?vue&type=template&id=386a38c9&"
import script from "./NoResultsButton.vue?vue&type=script&lang=js&"
export * from "./NoResultsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports